export default __webpack_public_path__ + "static/media/team-2.9c52ff7c.png";